"use client"

import React from 'react'
import { Tag } from '@sourcepilot/ui/framework/ui/atoms/tag'

import { NeoNodeReadAPI } from '@sourcepilot/generated/shared/types/neonode';

interface ThreadContextProps {
  contextItems?: NeoNodeReadAPI[];
  canAdd?: boolean;
}

export default function ThreadContext({ contextItems = [], canAdd=false }: ThreadContextProps) {
  const contexts = contextItems;

  if (contexts.length === 0 && !canAdd) {
    return null;
  }
  
  return (
      <div className="text-xs rounded-[5px] mt-[6px]" >
        <div className="w-full flex flex-wrap gap-2">
          {contexts.map((item, index) => (
          <Tag
            key={`context_${item.id}_${index}`}
            label = "Context"
            value = {item.id || ''}
          /> 
          ))}

          {canAdd && (
            <Tag
              key={`context_add`}
              addButton={true}
          />
          )}
        </div>
      </div>
  )
}

